import { Loading } from '@perch-labs/shrike';
import styled from 'styled-components';
import { ScrollablePdf } from '~/components/terms/scrollable-terms/scrollable-pdf.component';
import { usePreSignedContractPdf } from '~/hooks/use-pre-signed-contract-pdf';
import { SignupContractVersion } from '~/services/fetch-personalized-signup-contract-set-from-template';
import { getPersonalizedPreviewItems } from './modal-contract-link.component';

const ContractSection = styled.div`
  &:not(:last-child) {
    margin-bottom: 24px;
  }
`;

const getKeyForContract = (contract: SignupContractVersion, index: number): string => {
  const { key } = getPersonalizedPreviewItems(contract)[0] || {};
  return key || `contract-${contract.id}-${index}`;
};

const SingleContractPdf = ({ contract }: { contract: SignupContractVersion }) => {
  const { pdfUrl, isLoading } = usePreSignedContractPdf(contract);
  const previewItems = getPersonalizedPreviewItems(contract);

  if (isLoading) {
    return <Loading />;
  }

  if (previewItems.length > 0) {
    return (
      <>
        {previewItems.map((item, index) => (
          <span key={item.key}>
            <ScrollablePdf pdfUrl={item.pdfUrl} />
            {index < previewItems.length - 1 ? <hr /> : null}
          </span>
        ))}
      </>
    );
  }

  if (!pdfUrl) {
    return null;
  }

  return <ScrollablePdf pdfUrl={pdfUrl} />;
};

export const MultiContractScrollView = ({ contracts }: { contracts: SignupContractVersion[] }) => {
  return (
    <>
      {contracts.map((contract, index) => (
        <ContractSection key={getKeyForContract(contract, index)}>
          <SingleContractPdf contract={contract} />
        </ContractSection>
      ))}
    </>
  );
};
